import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAvailableDocumentsToAdd,
  setSelectedAccident,
} from "../../../../actions/accidentDashboard";
import {
  cleanAccidentsArt,
  cleanAccidentsWithFilters,
  getAccidentsArt,
} from "../../../../actions/accidents";
import { openNewForm, setFormsGeneralProperties } from "../../../../actions/formsState";
import { changeSelectedProviderWriUser, getProviders } from "../../../../actions/providers";
import { getTrasladosHistorial } from "../../../../actions/traslados";
import { StyledArtSearchContainer } from "../../../styled/accident";
import FormContainer from "../../forms/formContainer";
import AccidentDashboardContainer from "../../accident/accidentDashboard/accidentDashboardContainer";
import EditAccidentContainer from "../../accident/edit/editAccidentContainer";
import EditLogsContainer from "../../accident/edit/editLogsContainer";
import SearchSiniestrosArt from "./siniestroSearch";
import AccidentArtTable from "./siniestroTable";
import HistorialTrasladosDialog from "./historialTrasladosDialog";

const ArtSearchContainer = () => {
  const dispatch = useDispatch();

  const accidents = useSelector((state) => state.accidents.art);
  const roles = useSelector((state) => state.auth.roles);
  const historial = useSelector((state) => state.traslados.historial);
  const puedeOperarTraslados = Boolean(
    roles?.AGENTETRASLADOS || roles?.GESTORSINIESTROS,
  );

  const [displayAccidents, setDisplayAccidents] = useState("block");
  const [accidentToEdit, setAccidentToEdit] = useState(null);
  const [openLogsDialog, setOpenLogsDialog] = useState(null);
  const [idArt, setIdArt] = useState(null);
  const [historialAccident, setHistorialAccident] = useState(null);
  useEffect(() => {
    dispatch(cleanAccidentsWithFilters());
    dispatch(getProviders());
  }, []);

  const handleSearch = (params, selectedArtId) => {
    setIdArt(selectedArtId || null);
    dispatch(getAccidentsArt(params));
  };

  const handleResetSearch = () => {
    setIdArt(null);
    dispatch(cleanAccidentsArt());
  };

  const handleAccidentDetail = (accident) => {

    dispatch(changeSelectedProviderWriUser(accident.prestadorId));
    dispatch(setSelectedAccident(accident));
    setDisplayAccidents("none");

  };

  const postSubmitForm = (ret) => {
    const params = `accident=${ret?.value?.data?.ret?.siniestro?.split()}&idArt=${idArt}`;
    dispatch(getAccidentsArt(params));
  };

  const handleIngresarTraslado = useCallback(
    (accident) => {
      dispatch(changeSelectedProviderWriUser(accident.prestadorId));
      dispatch(setSelectedAccident(accident));
      dispatch(
        setFormsGeneralProperties({
          idSiniestro: accident.idSiniestro,
          idArt: accident.mlCloudCoreArtId || idArt,
          artName: accident.art,
          documento: accident.documento,
          trabajador:
            accident.trabajador ??
            `${accident.apellidoTrabajador ?? ""} ${accident.nombreTrabajador ?? ""}`.trim(),
          apellidoTrabajador: accident.apellidoTrabajador,
          nombreTrabajador: accident.nombreTrabajador,
          numeroHistoriaClinica: accident.siniestro,
        }),
      );

      dispatch(
        getAvailableDocumentsToAdd(
          accident.idSiniestro,
          accident.mlCloudCoreArtId || idArt,
        ),
      )
        .then((result) => {
          const documents = result?.value?.data ?? [];
          const fptForm = documents.find(
            (form) => String(form?.formulario ?? "").toLowerCase() === "fpt",
          );
          dispatch(
            openNewForm(
              "Fpt",
              fptForm?.nombre || "Formulario de Pedido de Traslado",
            ),
          );
        })
        .catch(() => {
          dispatch(openNewForm("Fpt", "Formulario de Pedido de Traslado"));
        });
    },
    [dispatch, idArt],
  );

  return (
    <StyledArtSearchContainer.Container>
      {displayAccidents === "none" ? (
        <AccidentDashboardContainer setDisplayAccidents={setDisplayAccidents} />
      )
        :
        (
          <>
            <div>
              <StyledArtSearchContainer.Title variant="h6">
                Buscar Siniestro
              </StyledArtSearchContainer.Title>
              <SearchSiniestrosArt
                handleSearch={handleSearch}
                handleReset={handleResetSearch}
                isSearching={accidents.isFetching}
              />
            </div>
            <AccidentArtTable
              data={accidents.data}
              loading={accidents.isFetching}
              error={accidents.didInvalidate}
              noRefresh
              handleAccidentDetail={handleAccidentDetail}
              displayAccidents={displayAccidents}
              handleEdit={(accident) => {
                dispatch(changeSelectedProviderWriUser(accident.prestadorId));
                setAccidentToEdit(accident)
              }}
              handleOpenLogsDialog={(accident) => setOpenLogsDialog(accident)}
              handleIngresarTraslado={
                puedeOperarTraslados ? handleIngresarTraslado : undefined
              }
              handleVerTrasladosAnteriores={
                puedeOperarTraslados
                  ? (accident) => {
                    setHistorialAccident(accident);
                    dispatch(
                      getTrasladosHistorial(
                        accident.mlCloudCoreArtId || idArt,
                        accident.idSiniestro,
                      ),
                    );
                  }
                  : undefined
              }
            />
            <EditAccidentContainer
              propsAction={postSubmitForm}
              accident={accidentToEdit}
              handleClose={() => setAccidentToEdit(null)}
            />
            <EditLogsContainer
              accident={openLogsDialog}
              handleClose={() => setOpenLogsDialog(null)}
            />
            <HistorialTrasladosDialog
              open={Boolean(historialAccident)}
              accident={historialAccident}
              data={historial.data}
              loading={historial.isFetching}
              onClose={() => setHistorialAccident(null)}
            />
            <FormContainer />
          </>
        )
      }
    </StyledArtSearchContainer.Container>
  );
};

export default ArtSearchContainer;
